var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tile, TileComment, TileHeader } from '../common/Tile';
import styled from 'styled-components';
import { LinkedInShareButton } from '../common/ShareButton';
var A = styled.a.attrs({ rel: 'noopener noreferrer', target: '_blank' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: inherit;\n"], ["\n  color: inherit;\n"])));
export default function ArticleContent(props) {
    // For staging/production
    var href = document.location.href;
    // For development (can't share localhost to LinkedIn):
    // const href = 'https://bootstrapworks.com/content';
    return (_jsxs(Tile, { children: [_jsx(TileHeader, { children: props.title }, void 0),
            _jsx(TileComment, { children: _jsxs("div", { children: [props.description, _jsx("br", {}, void 0),
                        _jsx("br", {}, void 0),
                        _jsxs(A, __assign({ href: props.url }, { children: [props.title, " "] }), void 0)] }, void 0) }, void 0),
            _jsx(LinkedInShareButton, { url: href }, void 0)] }, void 0));
}
var templateObject_1;
//# sourceMappingURL=ArticleContent.js.map